/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceGenerateInvoiceRequest
 */
export interface InvoiceGenerateInvoiceRequest {
    /**
     * 
     * @type {number}
     * @memberof InvoiceGenerateInvoiceRequest
     */
    invoiceId?: number;
}

/**
 * Check if a given object implements the InvoiceGenerateInvoiceRequest interface.
 */
export function instanceOfInvoiceGenerateInvoiceRequest(value: object): value is InvoiceGenerateInvoiceRequest {
    return true;
}

export function InvoiceGenerateInvoiceRequestFromJSON(json: any): InvoiceGenerateInvoiceRequest {
    return InvoiceGenerateInvoiceRequestFromJSONTyped(json, false);
}

export function InvoiceGenerateInvoiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceGenerateInvoiceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
    };
}

export function InvoiceGenerateInvoiceRequestToJSON(json: any): InvoiceGenerateInvoiceRequest {
    return InvoiceGenerateInvoiceRequestToJSONTyped(json, false);
}

export function InvoiceGenerateInvoiceRequestToJSONTyped(value?: InvoiceGenerateInvoiceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceId': value['invoiceId'],
    };
}

